import { PlusOutlined } from "@ant-design/icons";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow
} from "@mui/material";
import { Button as AntButton, Modal as AntModal, Card, Col, Divider, Input, Row } from "antd";
import filter from "lodash/filter";
import find from "lodash/find";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import sortBy from "lodash/sortBy";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { useGoogleCourseMapByDistrict } from "store/booksUnits/selectors";

import Loading from "components/Loading";
import DistrictPreviewModal from "components/admin/Licenses/LicenseUtilizationView";
import VocabAccessModal from "components/admin/VocabPermission";
import Login_as from "features/forms/admin/Login_as";
import COLOR from "utils/constants/color";
import { useCurrentOrg } from "store/organizations/selectors";
import { ArrowRight, Edit } from "@mui/icons-material";
import SpinLoader from "components/Loader/SpinLoader";
import { handleGetSchoolsForOrg, handleGetTeacherForSchool } from "store/organizations/thunks";
import usePermissionForUser from "components/hooks/permissions/usePermissionForUser";

const BORDERCOLOR = [
  "rgb(200,109,152)",
  "rgb(146,158,227)",
  "rgb(80,233,200)",
  "rgb(238,206,151)"
];



const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const SectionTitle = styled.p`
  color: black;
  font-size: 17px;
  font-weight: 400;
`;

const Highlight = styled.span`
  font-weight: 600;
`;

const ViewDemo = styled.span`
  margin-left: 4px;
  color: ${({ color }) => color};
`;

const Rotate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  transform: ${({ open }) => (open ? "rotate(90deg)" : "rotate(0deg)")};
  transition: transform 300ms ease;
`;

const ModalContent = styled.div`
  background: ${COLOR.white};
  border-radius: 3px;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;



export default function SchoolTable({
  userloading,
  onTabsJump = () => {},
  active_tab
}) {
  const {isUserCoach} = usePermissionForUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const googleMap = useGoogleCourseMapByDistrict();
  const currentOrg = useCurrentOrg()
  const [schools,setSchools] = useState([])

  // State
  const [pageInfo, setPageInfo] = useState({ page: 0, rowsPerPage: 100 });
  const [searchText, setSearchText] = useState("");
  const [expandedRow, setExpandedRow] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [licenseModal, setLicenseModal] = useState({ open: false, orgId: null });
  const [data_loading,setDataLoading] = useState(false);
  const [total_count, setToatalCount] = useState(0);
  const [teachersList,setTeachersList] = useState([])
  const last_fetched_org = useRef()
  const prevOrgIdRef = useRef(currentOrg?.id);
  useEffect(() => {
    setPageInfo({ page: 0, rowsPerPage: 50 })
  }, [currentOrg])
  async function getSchoolInfo() {
    try {
      const is_loading = last_fetched_org.current !== currentOrg.id
      setDataLoading(is_loading)
      const response = await dispatch(handleGetSchoolsForOrg(pageInfo.page*pageInfo.rowsPerPage,pageInfo.rowsPerPage,currentOrg.id))
      last_fetched_org.current = currentOrg.id
      if (response && response.success) {
        const { total_count, schools: schoolresult } = response.data || {};
        setToatalCount(total_count)
        setSchools(schoolresult)
        setExpandedRow(null)
      }
    } catch (error) {

    } finally {
      setDataLoading(false)
    }

  }
  useEffect(() => {
    if (currentOrg && currentOrg.id) {
      if(active_tab!="see_schools") return;
      getSchoolInfo()
    }
  }, [currentOrg, pageInfo,active_tab])

  useEffect(() => {
    if (active_tab !== "see_schools") return;
    if (prevOrgIdRef.current !== undefined && prevOrgIdRef.current !== currentOrg?.id) {
      setSearchText('');
    }
    prevOrgIdRef.current = currentOrg?.id;
  }, [currentOrg?.id, active_tab])

  const districtFiltered = useMemo(() => {
    if (currentOrg?.id) {
      return filter(schools, (s) => s.parentId === currentOrg.id);
    }
    return schools;
  }, [schools, currentOrg]);

  // Integration filter

  // Search filter
  const displayed = useMemo(() => {
    const list = districtFiltered;
    if (!searchText) return sortBy(list, ["displayName"]);
    const q = searchText.toLowerCase();
    return sortBy(
      list.filter((s) => s.displayName.toLowerCase().includes(q)),
      ["displayName"]
    );
  }, [districtFiltered, searchText]);

  // Pagination slice
  // const pageRows = useMemo(() => {
  //   const { page, rowsPerPage } = pageInfo;
  //   return displayed.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  // }, [displayed, pageInfo]);

  // Handlers

  const onSearch = useCallback((e) => {
    setSearchText(e.target.value);
  }, []);

  const onPageChange = useCallback((_, newPage) => {
    setPageInfo((p) => ({ ...p, page: newPage }));
  }, []);

  const onRowsPerPageChange = useCallback((e) => {
    setPageInfo({ page: 0, rowsPerPage: +e.target.value });
  }, []);
  const getTeacherForOrg = async (id) => {
    try {
      setDataLoading(true)
      const resposne = await dispatch(handleGetTeacherForSchool(id))
      if (resposne && resposne.success) {
        setTeachersList(resposne.data)
      }
    } catch (error) {
    } finally {
      setDataLoading(false)
    }

  }
  const toggleExpand = useCallback(
    (idx, id) => {
      setExpandedRow(expandedRow === idx ? null : idx);
      setTeachersList([])
      if (expandedRow !== idx) {
        getTeacherForOrg(id)
      }
    },
    [expandedRow]
  );
  const closeDetail = useCallback(() => setDetailOpen(false), []);

  const openLicenseModal = useCallback((orgId) => {
    setLicenseModal({ open: true, orgId });
  }, []);
  const closeLicenseModal = useCallback(() => {
    setLicenseModal({ open: false, orgId: null });
  }, []);



  const addSchools = useCallback(
    (isEdit = false) => {
      navigate("/add-schools", {
        state: isEdit
          ? { editSchool: true, school: detailData }
          : { editSchool: false, school: null }
      });
    },
    [navigate, detailData]
  );

  const checkIntegration = useCallback(
    (s) => {
      const parts = [];
      if(!s) return "-"
      if (s.cleverId) parts.push("Clever");
      if (s.classlinkid || s.classlinkTenantId) parts.push("Classlink");
      if (s.schoolId) parts.push("Schoology");
      if (s.canvas_id) parts.push("Canvas");
      if (find(googleMap, ["orgId", s.id])) parts.push("Google Classroom");
      return parts.length ? parts.join(", ") : "-";
    },
    [googleMap]
  );

  const substract = (a, b) => {
    const _a = parseInt(a) || 0;
    const _b = parseInt(b) || 0;
    return _a - _b;
  };

  return (
    <>
      <DistrictPreviewModal
        open={licenseModal.open}
        onClose={closeLicenseModal}
        orgId={licenseModal.orgId}
      />
      <SpinLoader dataloader={data_loading} />

      <Row style={{ marginBottom: 16 }} align="middle" justify="space-between">
        {isUserCoach ? null : (
        <AntButton type="primary" icon={<PlusOutlined />} onClick={() => addSchools(false)}>
          Add Schools
        </AntButton>
        )}
        <Input
          placeholder="Search Schools by name"
          value={searchText}
          onChange={onSearch}
          style={{ width: 250 }}
        />
      </Row>

      <SectionTitle>
        View <Highlight>School</Highlight> Records.
      </SectionTitle>
      <Wrapper>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                {[
                  "Name",
                  "District",
                  "Licenses",
                  "Licenses Used",
                  "Licenses Available",
                  "Students",
                  "Teachers",
                  "Integration"
                ].map((hdr, i) => (
                  <TableCell key={i} sx={{ fontSize: 16, fontWeight: 600, textAlign: "left" }}>
                    {hdr}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {isEmpty(displayed) ? (
                userloading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No results
                    </TableCell>
                  </TableRow>
                )
              ) : (
                displayed.map((row, idx) => {
                  if (!row) return null;
                  const districtName = currentOrg?.displayName || '';
                  return (
                    <React.Fragment key={row.id}>
                      <TableRow hover>
                        <TableCell onClick={() => row.teacher_count > 0 ? toggleExpand(idx, row.id) : null}>
                          {row.teacher_count > 0 && <Rotate open={expandedRow === idx}>
                            <ArrowRight />
                          </Rotate>}
                        </TableCell>
                        <TableCell
                          onClick={() => {
                            setDetailData({ ...row, districtName });
                            setDetailOpen(true);
                          }}
                          sx={{ cursor: "pointer" }}
                        >
                          {row.displayName}
                          {row.demo && <ViewDemo color={BORDERCOLOR[3]}>(Demo)</ViewDemo>}
                        </TableCell>
                        <TableCell>{districtName}</TableCell>
                        <TableCell
                          onClick={() => openLicenseModal(row.id)}
                          sx={{ color: BORDERCOLOR[0], cursor: "pointer" }}
                        >
                          {row.allocated_license}
                        </TableCell>
                        <TableCell
                          onClick={() => openLicenseModal(row.id)}
                          sx={{ color: BORDERCOLOR[1], cursor: "pointer" }}
                        >
                          {row.total_utilized || 0}
                        </TableCell>
                        <TableCell
                          onClick={() => openLicenseModal(row.id)}
                          sx={{ color: BORDERCOLOR[2], cursor: "pointer" }}
                        >
                          {row.remain_license}
                        </TableCell>
                        <TableCell
                          onClick={() => onTabsJump("see_students", row)}
                          sx={{ cursor: "pointer" }}
                        >
                          {get(row, "student_count", 0)}
                        </TableCell>
                        <TableCell
                          onClick={() => onTabsJump("see_teachers", row)}
                          sx={{ cursor: "pointer" }}
                        >
                          {get(row, "teacher_count", 0)}
                        </TableCell>
                        <TableCell>{checkIntegration(row)}</TableCell>
                      </TableRow>

                      {expandedRow === idx && (
                        <TableRow>
                          <TableCell colSpan={9}>
                            <Table size="small">
                              <TableBody>
                                {teachersList?.map((t) => (
                                  <TableRow key={t.id}>
                                    <TableCell align="center">
                                      {`${get(t, "firstName", "")} ${get(t, "lastName", "")}`}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Login_as user={t} />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total_count}
                  page={pageInfo.page}
                  rowsPerPage={pageInfo.rowsPerPage}
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onRowsPerPageChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  slotProps={{
                    actions: {
                      backIconButtonProps: { color: "secondary" },
                      nextIconButtonProps: { color: "secondary" }
                    }
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Wrapper>

      {/* Detail Modal */}
      <AntModal
        title={get(detailData, "displayName", "")}
        open={detailOpen}
        onCancel={closeDetail}
        footer={null}
        centered
        width="60%"
      >
        <Row justify="space-between" align="middle">
          {isUserCoach ? null : <AntButton  icon={<Edit />} onClick={() => addSchools(true)}>
            Edit Profile
          </AntButton>}
          <VocabAccessModal id={detailData?.id} type="school" />
        </Row>
        <Card type="inner" title="Detail View" style={{ marginTop: 16 }}>
          <Row gutter={16}>
            <Col span={12}>
              <p><strong>School Name:</strong> {get(detailData, "displayName", "")}</p>
              <p><strong>District:</strong> {get(detailData, "districtName", "")}</p>
              <p><strong>Licenses:</strong> {get(detailData, "licences_assignment.allocatedLicense", 0)}</p>
            </Col>
            <Col span={12}>
              <p><strong>Licenses Available:</strong> {substract(get(detailData, "licences_assignment.allocatedLicense", 0), detailData?.total_utilized || 0)}</p>
              <p><strong>Licenses Used:</strong> {detailData?.total_utilized || 0}</p>
              <p><strong>Integration:</strong> {checkIntegration(detailData)}</p>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={12}>
              <p>
                <strong>Students:</strong>{" "}
                <span
                  style={{ color: "#1464FF", cursor: "pointer" }}
                  onClick={() => onTabsJump("see_students", detailData)}
                >
                  {get(detailData, "student_count", 0)}
                </span>
              </p>
            </Col>
            <Col span={12}>
              <p>
                <strong>Teachers:</strong>{" "}
                <span
                  style={{ color: "#1464FF", cursor: "pointer" }}
                  onClick={() => onTabsJump("see_teachers", detailData)}
                >
                  {get(detailData, "teacher_count", 0)}
                </span>
              </p>
            </Col>
          </Row>
        </Card>
      </AntModal>
    </>
  );
}